import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { viewerActions } from '../actions/viewerAction';

export interface ViewerState {
    type: 'revision' | 'editing' | 'examination';
    actId: string;
    revision: string;
    editingId: string;
    stepId: string;
    miekesi: boolean;
    highlight: string;
    nodeId: string;
    contents: string;
    metadata: Metadata;
    caption: Caption[];
    countHasChild: number;
    actState: string;
    mode: 'history' | 'current';
    title: string;
    maxStepId: number;
    posNextPrev: number;
};

export interface Metadata {
    title: string,
    actNum: string,
    catalog: Catalog;
    field: Field[];
    history: History[];
    countHasCatalogChild: number;
    countHasHistoryChild: number;
};

export interface Catalog {
    name: string,
    child?: Catalog,
    level: number,
    hasChildIndex: number,
};

export interface Field {
    id: number,
    name: string
}

export interface History {
    editActNum: string,
    revisiondata: Revisiondata[],
    nodeId: string,
    uploadFile?: UploadFile[],
    level: number;
    hasChildIndex: number;
};

export interface UploadFile {
    type: 'RevisionAct' | 'ContrastTable' | 'Etc1' | 'Etc2' | 'Etc3',
    fileName: string,
    alias: string,
    delete?: boolean,
    fileObj?: any;
};

export interface Revisiondata {
    date: string,
    revision: string,
    type: '施行' | '公布',
    mode: 'V5以前' | 'V5' | 'OPPT',
    link: boolean,
    level: number,
    hasChildIndex: number
};

export interface Caption {
    id: string;
    value: string;
    editing?: Editing;
    otherEditing?: string;
    childCaptionList?: Caption[];
    level: number;
    hasChildIndex: number;
    type: string;
    deleteFlg: boolean;
    abbrevFlg: boolean;
    notviewFlg: boolean;
};

export interface Editing {
    editing?: string;
    editing_type?: string;
    editing_top?: boolean;
    editing_words?: boolean;
    editing_attr?: string;
    editing_table?: string;
}

const initialState: ViewerState = {
    type: 'revision',
    actId: '',
    revision: '',
    editingId: '',
    stepId: '',
    miekesi: false,
    highlight: '',
    nodeId: '',
    contents: '',
    metadata: {
        title: '',
        actNum: '',
        catalog: { name: '', level: 0, hasChildIndex: 0, },
        field: [],
        history: [],
        countHasCatalogChild: 1000,
        countHasHistoryChild: 1000,
    },
    caption: [],
    countHasChild: 1000,
    actState: '',
    mode: 'current',
    title: '',
    maxStepId: 1,
    posNextPrev: -1
};

export const viewerReducer = reducerWithInitialState(initialState)
    .case(viewerActions.initViewer, (state, payload) => {
        return Object.assign({}, state, {
            title: payload.title,
            type: payload.type,
            actId: payload.actId,
            revision: payload.revision,
            editingId: payload.editingId,
            stepId: payload.stepId,
            miekesi: payload.miekesi,
            highlight: payload.highlight,
            nodeId: payload.nodeId,
            contents: payload.contents,
            metadata: payload.metadata,
            caption: payload.caption,
            actState: payload.actState,
            maxStepId: payload.maxStepId,
            posNextPrev: payload.posNextPrev
        })
    }).case(viewerActions.setPosNextPrev, (state, payload) => {
        return Object.assign({}, state, {
            posNextPrev: payload
        });
    });
